import Vue from 'vue';
import VueRouter from 'vue-router';
import { getAuth } from "../firebase";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../components/dashboard.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/atletas',
    name: 'atletas',
    component: () => import('../components/atletas.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/editar-atleta',
    name: 'editar-atleta',
    component: () => import('../components/EditarAtleta.vue'),
  },
  {
    path: '/nuevo-atleta',
    name: 'nuevo-atleta',
    component: () => import('../components/NuevoAtleta.vue'),
  },
  {
    path: '/pagos-atleta',
    name: 'pagos-atleta',
    component: () => import('../components/PagosAtleta.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/pagos-de-atletas',
    name: 'pagos-de-atletas',
    component: () => import('../components/finanzas.vue'),
    meta: { requireAuth: true }
  },
  {
    path: '/reporte-de-pagos',
    name: 'reporte-de-pagos',
    component: () => import('../components/ReportarPago.vue'),
  },
  {
    path: '/buscador-atleta',
    name: 'buscador-atleta',
    component: () => import('../components/buscador-atleta.vue'),
  },
  {
    path: '/egresos',
    name: 'buscador-atleta',
    component: () => import('../components/Egresos.vue'),
    meta: { requireAuth: true }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requireAuth);
  const user = getAuth().currentUser;

  if (requiresAuth && !user) {
    next({ name: 'home' });
  } else {
    next();
  }
});

export default router;
